import { createAction } from '@reduxjs/toolkit';

export const FETCH_CALL_CDR_ACTION_TYPE = 'saga/fetchCallCdr';
export const fetchCallCdrAction = createAction(FETCH_CALL_CDR_ACTION_TYPE);
